import type { FC, ReactNode } from 'react'
import type { FlexProps, StackProps } from '@chakra-ui/react'
import { VStack } from '@chakra-ui/react'
import type { TopNavContentProps } from './TopNavContent'
import TopNavContent from './TopNavContent'

type ITopNav = StackProps &
  TopNavContentProps & {
    logo: ReactNode
    contentHeight: FlexProps['h']
    isHidden: boolean
    contentContainerProps?: FlexProps
  }

export const TopNav: FC<ITopNav> = ({
  menuItems,
  logo,
  contentHeight,
  isHidden,
  onMenuToggle,
  toggleIcon,
  onMenuHover,
  contentContainerProps,
  ...props
}) => {
  return (
    <VStack
      position="fixed"
      spacing={0}
      w="100%"
      zIndex={9000}
      bg="rgba(254, 254, 254, 0.92)"
      backdropFilter="blur(12px)"
      borderBottom="1px solid"
      borderColor="border.default"
      {...props}
    >
      <TopNavContent
        h={contentHeight}
        transition="all 0.25s ease"
        logo={logo}
        isHidden={isHidden}
        {...contentContainerProps}
        {...{
          menuItems,
          onMenuToggle,
          toggleIcon,
          onMenuHover
        }}
      />
    </VStack>
  )
}
